export const SKILL_TABS = [
  'Cruising',
  'Capital',
  'Defense',
  'Engineering',
  'Laser',
  'Railgun',
  'Cannon',
  'Decomposer',
  'Missile',
  'Drone',
  'Manufacture',
  'Refining',
  'Invention',
  'Misc',
];

export const SKILLS = {
  "Frigate Command": {level: 1, tab: 'Cruising', cost: [56320, 384000, 1536000]},
  "Destroyer Command": {level: 3, tab: 'Cruising', cost: [192000, 768000, 2304000]},
  "Cruiser Command": {level: 5, tab: 'Cruising', cost: [384000, 1536000, 3840000]},
  "Battlecruiser Command": {level: 7, tab: 'Cruising', cost: [563200, 2304000, 5632000]},
  "Battleship Command": {level: 9, tab: 'Cruising', cost: [768000, 3072000, 7680000]},
  "Industrial Ship Command": {level: 4, tab: 'Cruising', cost: [307200, 1228800, 3072000]},

  "Freighter Command": {level: 1, tab: 'Capital', cost: [1152000, 4608000, 11520000]},
  "Dreadnought Command": {level: 3, tab: 'Capital', cost: [1920000, 6400000, 15360000]},
  "Carrier Command": {level: 5, tab: 'Capital', cost: [1920000, 6400000, 15360000]},
  "Capital Industrial Ship Command": {level: 7, tab: 'Capital', cost: [1920000, 6400000, 15360000]},
  "Jump Freighter Command": {level: 9, tab: 'Capital', cost: [3072000, 6144000, 15360000]},
  "Force Auxiliary Command": {level: 4, tab: 'Capital', cost: [3072000, 6144000, 15360000]},
  "Versatile Assault Ship Command": {level: 4, tab: 'Capital', cost: [3072000, 6144000, 15360000]},

  "Afterburner": {level: 1, tab: 'Cruising', cost: [76800, 768000, 3072000]},
  "Microwarpdrive Operation": {level: 4, tab: 'Cruising', cost: [192000, 1152000, 4608000]},
  "Engine Operation": {level: 1, tab: 'Cruising', cost: [768000, 1536000, 5632000]},
  

  "Frigate Defense Upgrade": {level: 1, tab: 'Defense', cost: [56320, 384000, 1536000]},
  "Destroyer Defense Upgrade": {level: 3, tab: 'Defense', cost: [192000, 768000, 2304000]},
  "Cruiser Defense Upgrade": {level: 5, tab: 'Defense', cost: [384000, 1536000, 3840000]},
  "Battlecruiser Defense Upgrade": {level: 7, tab: 'Defense', cost: [563200, 2304000, 5632000]},
  "Battleship Defense Upgrade": {level: 9, tab: 'Defense', cost: [768000, 3072000, 7680000]},
  "Industrial Ship Defense Upgrade": {level: 4, tab: 'Defense', cost: [307200, 1228800, 3072000]},

  "Shield Operation": {level: 3, tab: 'Defense', cost: [192000, 1152000, 4608000]},
  "Shield Hardening": {level: 4, tab: 'Defense', cost: [192000, 947200, 3840000]},
  "Remote Shield Operation": {level: 5, tab: 'Defense', cost: [192000, 947200, 3840000]},

  "Armor Operation": {level: 3, tab: 'Defense', cost: [192000, 1152000, 4608000]},
  "Armor Hardening": {level: 3, tab: 'Defense', cost: [192000, 947200, 3840000]},
  "Remote Armor Operation": {level: 3, tab: 'Defense', cost: [192000, 947200, 3840000]},

  "Frigate Engineering": {level: 1, tab: 'Engineering', cost: [56320, 384000, 1536000]},
  "Destroyer Engineering": {level: 3, tab: 'Engineering', cost: [192000, 768000, 2304000]},
  "Cruiser Engineering": {level: 5, tab: 'Engineering', cost: [384000, 1536000, 3840000]},
  "Battlecruiser Engineering": {level: 7, tab: 'Engineering', cost: [563200, 2304000, 5632000]},
  "Battleship Engineering": {level: 9, tab: 'Engineering', cost: [768000, 3072000, 7680000]},
  "Industrial Ship Engineering": {level: 4, tab: 'Engineering', cost: [307200, 1228800, 3072000]},

  "Electronic Warfare": {level: 5, tab: 'Engineering', cost: [256000, 947200, 3840000]},
  "Propulsion Jamming": {level: 5, tab: 'Engineering', cost: [256000, 947200, 3840000]},
  "Signal Disruption": {level: 4, tab: 'Engineering', cost: [307200, 1228800, 3072000]},
  "Target Management": {level: 2, tab: 'Engineering', cost: [76800, 947200, 3840000]},

  "Small Laser Operation": {level: 3, tab: 'Laser', cost: [256000, 768000, 2099200]},
  "Small Laser Upgrade": {level: 4, tab: 'Laser', cost: [384000, 1536000, 3328000]},
  "Medium Laser Operation": {level: 5, tab: 'Laser', cost: [384000, 1536000, 4096000]},
  "Medium Laser Upgrade": {level: 6, tab: 'Laser', cost: [768000, 2304000, 5632000]},
  "Large Laser Operation": {level: 8, tab: 'Laser', cost: [1536000, 3072000, 8448000]},
  "Large Laser Upgrade": {level: 9, tab: 'Laser', cost: [2304000, 5376000, 11520000]},

  "Small Railgun Operation": {level: 3, tab: 'Railgun', cost: [256000, 768000, 2099200]},
  "Small Railgun Upgrade": {level: 4, tab: 'Railgun', cost: [384000, 1536000, 3328000]},
  "Medium Railgun Operation": {level: 5, tab: 'Railgun', cost: [384000, 1536000, 4096000]},
  "Medium Railgun Upgrade": {level: 6, tab: 'Railgun', cost: [768000, 2304000, 5632000]},
  "Large Railgun Operation": {level: 8, tab: 'Railgun', cost: [1536000, 3072000, 8448000]},
  "Large Railgun Upgrade": {level: 9, tab: 'Railgun', cost: [2304000, 5376000, 11520000]},

  "Small Cannon Operation": {level: 3, tab: 'Cannon', cost: [256000, 768000, 2099200]},
  "Small Cannon Upgrade": {level: 4, tab: 'Cannon', cost: [384000, 1536000, 3328000]},
  "Medium Cannon Operation": {level: 5, tab: 'Cannon', cost: [384000, 1536000, 4096000]},
  "Medium Cannon Upgrade": {level: 6, tab: 'Cannon', cost: [768000, 2304000, 5632000]},
  "Large Cannon Operation": {level: 8, tab: 'Cannon', cost: [1536000, 3072000, 8448000]},
  "Large Cannon Upgrade": {level: 9, tab: 'Cannon', cost: [2304000, 5376000, 11520000]},

  "Small Decomposer Operation": {level: 3, tab: 'Decomposer', cost: [256000, 768000, 2099200]},
  "Small Decomposer Upgrade": {level: 4, tab: 'Decomposer', cost: [384000, 1536000, 3328000]},
  "Medium Decomposer Operation": {level: 5, tab: 'Decomposer', cost: [384000, 1536000, 4096000]},
  "Medium Decomposer Upgrade": {level: 6, tab: 'Decomposer', cost: [768000, 2304000, 5632000]},
  "Large Decomposer Operation": {level: 8, tab: 'Decomposer', cost: [1536000, 3072000, 8448000]},
  "Large Decomposer Upgrade": {level: 9, tab: 'Decomposer', cost: [2304000, 5376000, 11520000]},

  "Small Missile Operation": {level: 3, tab: 'Missile', cost: [256000, 768000, 2099200]},
  "Small Missile Upgrade": {level: 4, tab: 'Missile', cost: [384000, 1536000, 3328000]},
  "Medium Missile Operation": {level: 5, tab: 'Missile', cost: [384000, 1536000, 4096000]},
  "Medium Missile Upgrade": {level: 6, tab: 'Missile', cost: [768000, 2304000, 5632000]},
  "Large Missile Operation": {level: 8, tab: 'Missile', cost: [1536000, 3072000, 8448000]},
  "Large Missile Upgrade": {level: 9, tab: 'Missile', cost: [2304000, 5376000, 11520000]},

  "Drone": {level: 3, tab: 'Drone', cost: [512000, 1024000, 5120000]},
  "Small Drone Operation": {level: 3, tab: 'Drone', cost: [256000, 768000, 2099200]},
  "Small Drone Upgrade": {level: 4, tab: 'Drone', cost: [384000, 1536000, 3328000]},
  "Medium Drone Operation": {level: 5, tab: 'Drone', cost: [384000, 1536000, 4096000]},
  "Medium Drone Upgrade": {level: 6, tab: 'Drone', cost: [768000, 2304000, 5632000]},
  "Large Drone Operation": {level: 8, tab: 'Drone', cost: [1536000, 3072000, 8448000]},
  "Large Drone Upgrade": {level: 9, tab: 'Drone', cost: [2304000, 5376000, 11520000]},

  "Frigate Manufacture": {level: 1, tab: 'Manufacture', cost: [56320, 384000, 1536000]},
  "Destroyer Manufacture": {level: 3, tab: 'Manufacture', cost: [192000, 768000, 2304000]},
  "Cruiser Manufacture": {level: 5, tab: 'Manufacture', cost: [384000, 1536000, 3840000]},
  "Battlecruiser Manufacture": {level: 7, tab: 'Manufacture', cost: [563200, 2304000, 5632000]},
  "Battleship Manufacture": {level: 9, tab: 'Manufacture', cost: [768000, 3072000, 7680000]},
  "Industrial Ship Manufacture": {level: 4, tab: 'Manufacture', cost: [307200, 1228800, 3072000]},
  "Module Manufacture": {level: 5, tab: 'Manufacture', cost: [384000, 1536000, 3840000]},
  "Rig Manufacture": {level: 4, tab: 'Manufacture', cost: [307200, 1228800, 3072000]},
  "Structure Construction": {level: 6, tab: 'Manufacture', cost: [768000, 2304000, 5376000]},

  "Common Ore Reprocessing": {level: 3, tab: 'Refining', cost: [384000, 1536000, 3328000]},
  "Uncommon Ore Reprocessing": {level: 4, tab: 'Refining', cost: [384000, 1536000, 3328000]},
  "Special Ore Reprocessing": {level: 5, tab: 'Refining', cost: [384000, 1536000, 3328000]},
  "Rare Ore Reprocessing": {level: 6, tab: 'Refining', cost: [563200, 2304000, 5120000]},
  "Precious Ore Reprocessing": {level: 7, tab: 'Refining', cost: [844800, 3328000, 7680000]},
  "Scrap Metal Processing": {level: 1, tab: 'Refining', cost: [768000, 3072000, 5632000]},

  "Amarr Invention Principles": {level: 5, tab: 'Invention', cost: [563200, 2304000, 5632000]},
  "Caldari Invention Principles": {level: 5, tab: 'Invention', cost: [563200, 2304000, 5632000]},
  "Gallente Invention Principles": {level: 5, tab: 'Invention', cost: [563200, 2304000, 5632000]},
  "Minmatar Invention Principles": {level: 5, tab: 'Invention', cost: [563200, 2304000, 5632000]},
  "Angel Invention Principles": {level: 5, tab: 'Invention', cost: [281600, 768000, 1920000]},
  "Blood Invention Principles": {level: 5, tab: 'Invention', cost: [281600, 768000, 1920000]},
  "Guristas Invention Principles": {level: 5, tab: 'Invention', cost: [281600, 768000, 1920000]},
  "Serpentis Invention Principles": {level: 5, tab: 'Invention', cost: [281600, 768000, 1920000]},
  "Sansha Invention Principles": {level: 5, tab: 'Invention', cost: [281600, 768000, 1920000]},
  "ORE Invention Principles": {level: 5, tab: 'Invention', cost: [281600, 768000, 1920000]},
  "InterBus Invention Principles": {level: 5, tab: 'Invention', cost: [281600, 768000, 1920000]},

  "Mining": {level: 4, tab: 'Misc', cost: [256000, 768000, 1920000]},
  "Strip Mining": {level: 6, tab: 'Misc', cost: [768000, 1920000, 4864000]},
  "Planetology": {level: 1, tab: 'Misc', cost: [281600, 1920000, 7680000]},
  "Trade": {level: 4, tab: 'Misc', cost: [384000, 1536000, 3328000]},
  "Accounting": {level: 5, tab: 'Misc', cost: [384000, 1536000, 3328000]},
  "Freight": {level: 4, tab: 'Misc', cost: [384000, 1536000, 3328000]},
};

const basicSkills = [
  'Microwarpdrive Operation 1',
  'Microwarpdrive Operation 2',
  'Microwarpdrive Operation 3',
  'Microwarpdrive Operation 4',
  'Advanced Microwarpdrive Operation 1',
  'Advanced Microwarpdrive Operation 2',
  'Advanced Microwarpdrive Operation 3',
  'Advanced Microwarpdrive Operation 4',
  'Target Management 1',
  'Target Management 2',
  'Target Management 3',
  'Target Management 4',
  'Advanced Target Management 1',
  'Advanced Target Management 2',
  'Advanced Target Management 3',
  'Advanced Target Management 4',
];

const basicEWSkills = [
  'Electronic Warfare 1',
  'Electronic Warfare 2',
  'Electronic Warfare 3',
  'Electronic Warfare 4',
  'Advanced Electronic Warfare 1',
  'Advanced Electronic Warfare 2',
  'Advanced Electronic Warfare 3',
  'Signal Disruption 1',
  'Signal Disruption 2',
  'Signal Disruption 3',
  'Signal Disruption 4',
  'Advanced Signal Disruption 1',
  'Advanced Signal Disruption 2',
  'Advanced Signal Disruption 3',
];

const basicShieldSkills = [
  'Shield Hardening 1',
  'Shield Hardening 2',
  'Shield Hardening 3',
  'Shield Hardening 4',
  'Advanced Shield Hardening 1',
  'Advanced Shield Hardening 2',
  'Advanced Shield Hardening 3',
  'Advanced Shield Hardening 4',
  'Remote Shield Operation 1',
  'Remote Shield Operation 2',
  'Remote Shield Operation 3',
  'Remote Shield Operation 4',
  'Advanced Remote Shield Operation 1',
  'Advanced Remote Shield Operation 2',
  'Advanced Remote Shield Operation 3',
  'Advanced Remote Shield Operation 4',
];

function basicShipSkills(shipType) {
  return [
    `${shipType} Command 1`,
    `${shipType} Command 2`,
    `${shipType} Command 3`,
    `${shipType} Command 4`,
    `Advanced ${shipType} Command 1`,
    `Advanced ${shipType} Command 2`,
    `Advanced ${shipType} Command 3`,
    `Advanced ${shipType} Command 4`,
    `${shipType} Engineering 1`,
    `${shipType} Engineering 2`,
    `${shipType} Engineering 3`,
    `${shipType} Engineering 4`,
    `Advanced ${shipType} Engineering 1`,
    `Advanced ${shipType} Engineering 2`,
    `Advanced ${shipType} Engineering 3`,
    `Advanced ${shipType} Engineering 4`,
    `${shipType} Defense Upgrade 1`,
    `${shipType} Defense Upgrade 2`,
    `${shipType} Defense Upgrade 3`,
    `${shipType} Defense Upgrade 4`,
    `Advanced ${shipType} Defense Upgrade 1`,
    `Advanced ${shipType} Defense Upgrade 2`,
    `Advanced ${shipType} Defense Upgrade 3`,
    `Advanced ${shipType} Defense Upgrade 4`,
  ]
}

function basicWeaponSkills(weaponType) {
  return [].concat(basicEWSkills, [
    `${weaponType} Operation 1`,
    `${weaponType} Operation 2`,
    `${weaponType} Operation 3`,
    `${weaponType} Operation 4`,
    `Advanced ${weaponType} Operation 1`,
    `Advanced ${weaponType} Operation 2`,
    `Advanced ${weaponType} Operation 3`,
    `Advanced ${weaponType} Operation 4`,
    `${weaponType} Upgrade 1`,
    `${weaponType} Upgrade 2`,
    `${weaponType} Upgrade 3`,
    `${weaponType} Upgrade 4`,
    `Advanced ${weaponType} Upgrade 1`,
    `Advanced ${weaponType} Upgrade 2`,
    `Advanced ${weaponType} Upgrade 3`,
    `Advanced ${weaponType} Upgrade 4`,      
  ])
}

const basicDroneSkills = [
  'Drone 1',
  'Drone 2',
  'Drone 3',
  'Drone 4',
  'Drone 5',
  'Advanced Drone 1',
  'Advanced Drone 2',
  'Advanced Drone 3',
  'Advanced Drone 4',
  // 'Advanced Drone 5',
  // 'Expert Drone 1',
  // 'Expert Drone 2',
  // 'Expert Drone 3',
  // 'Expert Drone 4',
];

const advancedDroneSkills = [
  'Drone 1',
  'Drone 2',
  'Drone 3',
  'Drone 4',
  'Drone 5',
  'Advanced Drone 1',
  'Advanced Drone 2',
  'Advanced Drone 3',
  'Advanced Drone 4',
  'Advanced Drone 5',
  'Expert Drone 1',
  'Expert Drone 2',
  'Expert Drone 3',
  'Expert Drone 4',
];

function makeBasicSkills(shipType, weaponType) {
  return [].concat(
      basicSkills,
      basicShieldSkills,
      basicShipSkills(shipType),
      weaponType ? basicWeaponSkills(weaponType) : [],
  )
}

const doctrineThrasherInterdictor = [
  'Destroyer Command 1',
  'Destroyer Command 2',
  'Destroyer Command 3',
  'Destroyer Command 4',
  'Advanced Destroyer Command 1',
  'Advanced Destroyer Command 2',
  'Advanced Destroyer Command 3',
  'Propulsion Jamming 1',
  'Propulsion Jamming 2',
  'Propulsion Jamming 3',
  'Destroyer Engineering 1',
  'Destroyer Engineering 2',
  'Destroyer Engineering 3',
  'Destroyer Engineering 4',
  'Advanced Destroyer Engineering 1',
  'Advanced Destroyer Engineering 2',
  'Advanced Destroyer Engineering 3',
  'Advanced Destroyer Engineering 4',
  'Advanced Destroyer Command 4',
  'Destroyer Defense Upgrade 1',
  'Destroyer Defense Upgrade 2',
  'Destroyer Defense Upgrade 3',
  'Destroyer Defense Upgrade 4',
  'Advanced Destroyer Defense Upgrade 1',
  'Advanced Destroyer Defense Upgrade 2',
  'Advanced Destroyer Defense Upgrade 3',
  'Advanced Destroyer Defense Upgrade 4',
  'Advanced Destroyer Command 5',
  'Expert Destroyer Command 1',
  'Expert Destroyer Command 2',
  'Expert Destroyer Command 3',
];

export const DOCTRINES = {
  'Hurricane (Banzai Fleet)': [].concat(
      makeBasicSkills('Battlecruiser', 'Medium Cannon'),
      [
        'Advanced Battlecruiser Engineering 5',
      ],
  ),
  'Naga (Dragon Fleet)': [].concat(
      makeBasicSkills('Battlecruiser', 'Large Railgun'),
      [
        'Advanced Battlecruiser Engineering 5',
        'Advanced Battlecruiser Command 5',
      ],
  ),
  'Arbitrator Covert Ops': [].concat(
      makeBasicSkills('Cruiser', 'Medium Cannon'),
      basicDroneSkills,
      basicWeaponSkills('Medium Drone'),
      [
          'Medium Drone Operation 5',
          'Medium Drone Upgrade 5',
      ]
  ),
  'Scythe': [].concat(
    makeBasicSkills('Cruiser', '')
  ),
  'Moa II Guardian': [].concat(
    makeBasicSkills('Cruiser', 'Medium Cannon'),
      [
          'Shield Hardening 5',
      ]
  ),
  'Slasher II': [].concat(
      makeBasicSkills('Frigate', 'Small Cannon'),
      [
          'Frigate Defense Upgrade 5',
      ]
  ),
  'Merlin Assault (Frigate Fleet)': makeBasicSkills('Frigate', 'Small Railgun'),
  'Breacher Assault (Frigate Fleet)': makeBasicSkills('Frigate', 'Small Missile'),
  'Stabber Fleet Issue (Hero Fleet, being phased out)': makeBasicSkills('Cruiser', 'Medium Cannon'),
  'Vexor Navy Issue (Hero Fleet, being phased out)': [].concat(
      makeBasicSkills('Cruiser', 'Medium Drone'),
      advancedDroneSkills,
  ),
  // // 'Stabber Fleet Issue (advanced)': doctrineSFIAdvanced,
  // 'Thrasher II (Utility)': doctrineThrasher,
  'Interdictor (Utility)': doctrineThrasherInterdictor,
};

export const SHIP_DATA = {
  "Griffin": [1056000, 1.9],
  "Vigil E-War": [1191300, 1.95],
  "Inquisitor": [1630000, 2.5],
  "Navitas II": [1450000, 2.57],
  "Thrasher Guardian": [1235000, 2.2],
  "Coercer Interdictor": [1300000, 2.5],
  "Catalyst II Interdictor": [1550000, 2.1],
  "Maller Guardian": [11750000, 0.36],
  "Thorax II Guardian": [11460000, 0.42],
  "Myrmidon Guardian": [12700000, 0.53],
  "Orca": [150000000, 0.26],
  "Griffin E-War": [1228700, 2],
  "Burst": [1420000, 2.4],
  "Inquisitor II": [1630000, 2.55],
  "Atron": [1050000, 1.1],
  "Cormorant Guardian": [1300000, 2.3],
  "Thrasher Interdictor": [1285000, 2.4],
  "Coercer II Interdictor": [1650000, 2],
  "Catalyst": [1550000, 2.1],
  "Rupture Guardian": [11590000, 0.36],
  "Maller II Guardian": [11750000, 0.41],
  "Celestis": [12070000, 0.38],
  "Prophecy Guardian": [15300000, 0.49],
  "Myrmidon II Guardian": [12700000, 0.51],
  "Megathron Striker": [98400000, 0.114],
  "Ibis": [1163000, 1.8],
  "Breacher Assault": [1366000, 2.75],
  "Purifier": [1495000, 2.5],
  "Nemesis II": [1410000, 2.55],
  "Corax Sniper": [1100000, 2.4],
  "Thrasher Covert Ops": [1235000, 1.9],
  "Moa": [12000000, 0.39],
  "Rupture": [12200000, 0.36],
  "Omen Trainer": [13000000, 0.32],
  "Thorax Trainer": [11280000, 0.41],
  "Drake": [13500000, 0.48],
  "Cyclone Command": [12800000, 0.53],
  "Prophecy II Command": [13500000, 0.48],
  "Capsule": [32000, 10],
  "Vigil": [1080000, 1.85],
  "Crucifier E-War": [1223200, 2],
  "Navitas": [1450000, 2.55],
  "Coercer Guardian": [1250000, 2.3],
  "Catalyst Interdictor": [1200000, 2.6],
  "Thorax Guardian": [11460000, 0.41],
  "Humpback Combat": [150000000, 0.28],
  "Venture III": [1600000, 2.2],
  "Merlin Assault": [1217000, 2.9],
  "Hound": [1455000, 2.3],
  "Purifier II": [1495000, 2.5],
  "Cormorant Covert Ops": [1300000, 2],
  "Caracal Navy Issue": [9600000, 0.38],
  "Stabber Trainer": [11400000, 0.31],
  "Maller Trainer": [13150000, 0.36],
  "Vexor Sniper": [10600000, 0.32],
  "Ferox Command": [14000000, 0.5],
  "Cyclone II Command": [12800000, 0.51],
  "Harbinger Prototype": [15500000, 0.42],
  "Manticore": [1470000, 2.5],
  "Hound II": [1455000, 2.3],
  "Imicus": [997000, 2.2],
  "Caracal Trainer": [11910000, 0.32],
  "Rupture Trainer": [12200000, 0.36],
  "Omen Sniper": [12580000, 0.31],
  "Celestis Covert Ops": [11650000, 0.44],
  "Ferox II Command": [14000000, 0.48],
  "Hurricane Prototype": [12800000, 0.46],
  "Manticore II": [1470000, 2.5],
  "Magnate": [1072000, 2],
  "Imicus Covert Ops": [1271000, 2.65],
  "Moa Trainer": [12000000, 0.39],
  "Stabber Sniper": [11750000, 0.29],
  "Arbitrator Covert Ops": [11370000, 0.46],
  "Celestis II Covert Ops": [11650000, 0.44],
  "Probe": [1123000, 1.9],
  "Magnate Covert Ops": [1147000, 2.6],
  "Caracal Sniper": [12720000, 0.38],
  "Bellicose Covert Ops": [11040000, 0.44],
  "Arbitrator II Covert Ops": [11370000, 0.46],
  "Thorax Prototype": [11280000, 0.41],
  "Heron": [1150000, 2],
  "Probe Covert Ops": [1430000, 2.45],
  "Blackbird Covert Ops": [12230000, 0.48],
  "Bellicose II Covert Ops": [11040000, 0.44],
  "Heron Covert Ops": [1270000, 2.6],
  "Blackbird II Covert Ops": [12230000, 0.48],
  "Bantam": [1480000, 2.5],
  "Burst II": [1420000, 2.4],
  "Executioner": [1090000, 1],
  "Tristan": [1044000, 1.55],
  "Cormorant Interdictor": [1350000, 2.5],
  "Thrasher II Interdictor": [1600000, 1.9],
  "Coercer": [1650000, 2],
  "Algos": [1600000, 2.2],
  "Moa Guardian": [11720000, 0.39],
  "Rupture II Guardian": [11590000, 0.37],
  "Arbitrator": [11200000, 0.42],
  "Celestis E-War": [12070000, 0.41],
  "Cyclone Guardian": [12400000, 0.52],
  "Prophecy II Guardian": [15300000, 0.47],
  "Brutix E-War": [11800000, 0.5],
  "Armageddon": [105200000, 0.13],
  "Dominix": [100250000, 0.1254],
  "Kryos": [12625000, 0.69],
  "Bantam II": [1480000, 2.55],
  "Slasher": [1075000, 1],
  "Tormentor": [1080000, 1.5],
  "Incursus": [1028000, 1.85],
  "Cormorant II Interdictor": [1700000, 2],
  "Thrasher": [1600000, 1.9],
  "Dragoon": [1700000, 2.2],
  "Catalyst II": [1550000, 2.1],
  "Moa II Guardian": [11720000, 0.41],
  "Bellicose": [11550000, 0.38],
  "Arbitrator E-War": [11810000, 0.4],
  "Exequror": [11020000, 0.46],
  "Ferox Guardian": [13250000, 0.49],
  "Cyclone II Guardian": [12400000, 0.5],
  "Harbinger E-War": [15500000, 0.5],
  "Talos": [15552000, 0.34],
  "Maelstrom Striker": [103600000, 0.136],
  "Apocalypse Striker": [97100000, 0.119],
  "Megathron": [98400000, 0.114],
  "Bestower": [13500000, 0.71],
  "Nereus": [11250000, 0.98],
  "Condor": [1100000, 1],
  "Rifter": [1067000, 1.4],
  "Punisher": [1190000, 1.8],
  "Atron II": [950000, 1.3],
  "Cormorant": [1700000, 2],
  "Talwar": [1650000, 2.1],
  "Coercer II": [1650000, 2],
  "Catalyst Navy Issue": [1550000, 2.1],
  "Blackbird": [13190000, 0.36],
  "Bellicose E-War": [11550000, 0.38],
  "Augoror": [12870000, 0.42],
  "Thorax Interdictor": [11460000, 0.41],
  "Ferox II Guardian": [13250000, 0.47],
  "Hurricane E-War": [12800000, 0.47],
  "Oracle": [14760000, 0.37],
  "Talos II": [15552000, 0.6],
  "Scorpion": [103600000, 0.116],
  "Maelstrom": [103600000, 0.136],
  "Apocalypse": [97100000, 0.119],
  "Hyperion": [100200000, 0.1178],
  "Wreathe": [10000000, 0.95],
  "Sigil": [11000000, 1],
  "Nereus II": [11250000, 0.58],
  "Breacher": [1087000, 1.7],
  "Executioner II": [1140000, 1.2],
  "Atron Interceptor": [1060000, 1.2],
  "Corax": [1750000, 2.2],
  "Thrasher II": [1600000, 1.9],
  "Coercer Navy Issue": [1650000, 2],
  "Algos Assault": [1600000, 2.4],
  "Blackbird E-War": [12730000, 0.4],
  "Scythe": [11110000, 0.45],
  "Maller Interdictor": [11750000, 0.36],
  "Celestis Interdictor": [12070000, 0.38],
  "Drake E-War": [13500000, 0.49],
  "Tornado": [15228000, 0.35],
  "Oracle II": [14760000, 0.61],
  "Brutix Logistics": [11800000, 0.51],
  "Raven Striker": [99300000, 0.12],
  "Typhoon": [100600000, 0.11],
  "Abaddon": [103200000, 0.14],
  "Tayra": [13000000, 0.72],
  "Mammoth": [11500000, 0.68],
  "Sigil II": [11000000, 0.65],
  "Kestrel": [997000, 1.8],
  "Slasher II": [1010000, 1.1],
  "Executioner Interceptor": [1050000, 1.2],
  "Atron II Interceptor": [1060000, 1.1],
  "Cormorant II": [1700000, 2],
  "Thrasher Fleet Issue": [1600000, 1.9],
  "Dragoon Assault": [1700000, 2.35],
  "Algos Trainer": [1600000, 2.2],
  "Osprey": [11100000, 0.46],
  "Rupture Interdictor": [11590000, 0.36],
  "Arbitrator Interdictor": [11200000, 0.42],
  "Vexor": [11100000, 0.335],
  "Naga": [15000000, 0.39],
  "Tornado II": [15228000, 0.56],
  "Harbinger Logistics": [15500000, 0.51],
  "Myrmidon": [12700000, 0.49],
  "Rokh": [105300000, 0.136],
  "Tempest": [99500000, 0.116],
  "Badger": [10650000, 1.1],
  "Wreathe II": [10000000, 0.61],
  "Condor II": [1065000, 1.2],
  "Slasher Interceptor": [1100000, 1.1],
  "Executioner II Interceptor": [1050000, 1],
  "Velator": [1148000, 1.8],
  "Cormorant Navy Issue": [1700000, 2],
  "Talwar Assault": [1650000, 2.2],
  "Dragoon Trainer": [1700000, 2.2],
  "Algos Sniper": [1050000, 2.4],
  "Moa Interdictor": [11720000, 0.39],
  "Bellicose Interdictor": [11550000, 0.38],
  "Omen": [13000000, 0.32],
  "Vexor Navy Issue": [11310000, 0.32],
  "Naga II": [15000000, 0.59],
  "Hurricane Logistics": [12800000, 0.48],
  "Prophecy": [15300000, 0.4],
  "Brutix": [11800000, 0.5],
  "Raven": [99300000, 0.12],
  "Badger II": [10650000, 0.71],
  "Condor Interceptor": [1050000, 1.2],
  "Slasher II Interceptor": [1100000, 1],
  "Impairor": [1148000, 1.8],
  "Incursus Assault": [1216000, 2.85],
  "Corax Assault": [1750000, 2.35],
  "Talwar Trainer": [1650000, 2.1],
  "Dragoon Sniper": [1800000, 2.3],
  "Catalyst Covert Ops": [1150000, 2.1],
  "Blackbird Interdictor": [13190000, 0.36],
  "Stabber": [11400000, 0.31],
  "Maller": [13150000, 0.36],
  "Thorax": [11280000, 0.41],
  "Drake Logistics": [13500000, 0.5],
  "Cyclone": [12400000, 0.48],
  "Harbinger": [15500000, 0.42],
  "Myrmidon Command": [13000000, 0.54],
  "Xian-Yue Prototype": [1650000, 2.5],
  "Daredevil": [823000, 1.8],
  "Xian-Yue": [1650000, 2.5],
  "Succubus": [965000, 2.4],
  "Can-Yue Prototype": [12800000, 0.5],
  "Garmur": [987000, 2.4],
  "Vigilant": [9830000, 0.38],
  "Can-Yue": [12800000, 0.5],
  "Phantasm": [9600000, 0.4],
  "Astero": [975000, 2.2],
  "Orthrus": [9362000, 0.36],
  "Vindicator": [105200000, 0.083],
  "Nightmare": [99300000, 0.122],
  "Stratios": [9350000, 0.5],
  "Barghest": [98467000, 0.098],
  "Condor II Interceptor": [1050000, 1],
  "Reaper": [1157000, 1.8],
  "Punisher Assault": [1171000, 2.9],
  "Nemesis": [1410000, 2.55],
  "Corax Trainer": [1750000, 2.2],
  "Talwar Sniper": [1400000, 2.25],
  "Coercer Covert Ops": [1250000, 2],
  "Caracal": [11910000, 0.32],
  "Stabber Fleet Issue": [10810000, 0.29],
  "Omen Navy Issue": [10850000, 0.31],
  "Vexor Trainer": [11100000, 0.335],
  "Ferox": [13250000, 0.42],
  "Hurricane": [12800000, 0.46],
  "Prophecy Command": [13500000, 0.5],
  "Myrmidon II Command": [13000000, 0.52],
  "Cruor": [1003000, 2.7],
  "Nestor": [20000000, 0.35],
  "Dramiel": [950000, 1.6],
  "Worm": [981000, 2.85],
  "Ashimmu": [11010000, 0.39],
  "Cynabal": [9047000, 0.34],
  "Retriever": [20000000, 0.5],
  "Gila": [9600000, 0.4],
  "Bhaalgorn": [97100000, 0.125],
  "Nereus High Mobility": [11250000, 0.68],
  "Procurer": [10000000, 0.6],
  "Machariel": [94680000, 0.096],
  "Nereus Combat": [20050000, 0.38],
  "Covetor": [30000000, 0.5],
  "Merlin": [1113000, 1.5],
  "Rattlesnake": [99300000, 0.128],
  "Nereus Hauling": [18550000, 0.85],
  "Porpoise": [4500000, 0.8],
  "Imicus High Mobility": [997000, 2.5],
  "Venture Trainer": [1200000, 3],
  "Maulus": [1063000, 1.92],
  "Humpback High Mobility": [150000000, 0.22],
  "Venture": [1200000, 3],
  "Crucifier": [1064000, 1.9],
  "Maulus E-War": [1204500, 2.05],
  "Catalyst Guardian": [1150000, 2.4],
  "Humpback Hauling": [150000000, 0.29],
  "Venture II": [1400000, 3],
};